// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ListTokens } from './type';

const listTokens: ListTokens = {
  listFontSize: '14/regular',
  listFontColor: 'Neutral-text-5',
  listBorderColor: 'Neutral-border-1',
  listBorderRadius: 'Radius-2',
  listItemPaddingY: 'Padding-12',
  listItemPaddingX: 'Padding-16',
  listSmallItemPaddingY: 'Padding-8',
  listSmallItemPaddingX: 'Padding-12',
  listLargeItemPaddingY: 'Padding-16',
  listLargeItemPaddingX: 'Padding-20',
  listPaginationMarginY: 'Margin-12',
  listStripedBackgroundColor: 'Neutral-fill-2',
};

export default listTokens;
